import {retry} from '@rambler-id/promise'

export const rambler = retry<any>(() => import('./rambler'))
export const universal = retry<any>(() => import('./universal'))
